import { isEmail, isPasswordValid, isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../helpers/reducer';
import { keyBy } from '../../../helpers/core';
import { steps } from '../../../redux/auth/reducer';
import { t } from '../../../i18n';

const getInitState = () => ({
  firstInput: {
    value: '',
    error: '',
    name: 'firstInput',
    touched: false,
  },
  secondInput: {
    value: '',
    error: '',
    name: 'secondInput',
    touched: false,
  },
  formSubmitted: {
    emailForm: false,
    emailPasswordForm: false,
    resetPasswordForm: false,
    passwordSSOForm: false,
  },
});

function validate({ attr, value, step, state }) {
  let error = '';
  const defaultErrorMessage = t('dash.signIn.password_requirements_message');
  const type = [steps.LOGIN, steps.RESET_PASSWORD, steps.START].includes(step) ? 'login' : 'password';

  if (type === 'login' && attr === 'firstInput') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.signIn.email_field_label') });
    } else if (!isEmail(value)) {
      error = t('dash.validation.valid_error', { fieldName: t('dash.signIn.email_field_label') });
    }
  }

  if (type === 'login' && attr === 'secondInput') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.signIn.password_label') });
    }
  }

  if (type === 'password') {
    if (!isPasswordValid(value)) {
      error = defaultErrorMessage;
    }
  }

  if (type === 'password' && attr === 'firstInput') {
    if (state.secondInput.value && value !== state.secondInput.value) {
      error = t('dash.signIn.passwords_are_not_equal_error');
    } else if (state.secondInput.value) {
      state.secondInput.error = !isPasswordValid(state.secondInput.value) ? defaultErrorMessage : '';
    } else {
      state.secondInput.error = '';
    }
  }

  if (type === 'password' && attr === 'secondInput') {
    if (state.secondInput.value && state.firstInput.value && value !== state.firstInput.value) {
      error = t('dash.signIn.passwords_are_not_equal_error');
    } else if (state.firstInput.value) {
      state.firstInput.error = !isPasswordValid(state.firstInput.value) ? defaultErrorMessage : '';
    } else {
      state.firstInput.error = '';
    }
  }

  return error;
}

function onChangeProperty(state, { payload }) {
  const { attr, value, step, error, touched } = payload;

  const updatedState = {
    ...state,
    [attr]: {
      value,
      error: error === '' ? error : validate({ attr, value, step, state }),
      name: attr,
      touched: touched === false ? touched : true,
    },
  };

  return updatedState;
}

function onTouch(state, { payload }) {
  const { step } = payload || {};
  const propsArray = Object.entries(state);

  const updatedState = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, item] = entry;

      return {
        ...item,
        touched: true,
        error:
          step || step === steps.LOGIN || step === steps.START
            ? validate({ attr: item.name, value: item.value, step, state })
            : '',
      };
    },
  );

  return { ...updatedState };
}

function onClearStore() {
  return getInitState();
}

function onSetFormSubmitted(state, { payload }) {
  const { form, submitted } = payload;

  return {
    ...state,
    formSubmitted: {
      ...state.formSubmitted,
      [form]: submitted,
    },
  };
}

export default createReducer(getInitState(), {
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.TOUCH]: onTouch,
  [actions.SET_FORM_SUBMITTED]: onSetFormSubmitted,
});
